import DOMPurify from 'dompurify'
import { textFormatBold } from './Regex'

export const textToHtml = (text: string): string => {
  const secureText = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] })
  return secureText.replace(new RegExp(textFormatBold, 'gm'), (_a, b) => {
    return `<b>${b}</b>`
  })
}

export const detectOS = (userAgent: string = navigator.userAgent): 'ios' | 'android' | 'web' => {
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios'
  if (/android/i.test(userAgent)) return 'android'
  return 'web'
}